import React, { Suspense, lazy } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const NetworkGraphic = lazy(() => import('./NetworkGraphic').then(m => ({
  default: m.NetworkGraphic
})));
const paths = [{
  audience: 'For Employers',
  title: 'Hiring for a senior or specialist role?',
  body: 'Executive search, talent sourcing, and recruitment support shaped around your role requirements and hiring priorities.',
  cta: 'Hire Talent With Us',
  to: '/employers'
}, {
  audience: 'For Professionals',
  title: 'Considering your next career move?',
  body: 'Register your interest to be considered for relevant senior and leadership opportunities aligned with your experience.',
  cta: 'Explore Career Opportunities',
  to: '/candidates'
}];
export function AudienceSplit() {
  const renderPath = (p: (typeof paths)[number], className: string) => <Reveal className={`flex flex-col px-6 py-12 lg:px-10 lg:py-16 ${className}`} data-id="element-41" data-mp="26vd51jlh9sll">
      <p className="text-sm font-medium text-gold" data-id="element-42" data-mp="ly8ca6ko6kta">{p.audience}</p>
      <h2 className="mt-4 font-serif text-3xl font-medium leading-tight text-white lg:text-[32px]" data-id="element-43" data-mp="quyqeocwz6c2">
        {p.title}
      </h2>
      <p className="mt-4 max-w-md leading-relaxed text-white/70" data-id="element-44" data-mp="uvsebhqcwl4y">{p.body}</p>
      <Link to={p.to} className="group mt-auto inline-flex items-center gap-2 self-start pt-8 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:text-gold focus-visible:outline-none focus-visible:text-gold" data-id="element-45" data-mp="zxhnssxxkqqx">
        <span className="border-b border-gold pb-0.5" data-id="element-46" data-mp="1elb3seqxhva1">{p.cta}</span>
        <ArrowRightIcon size={16} strokeWidth={1.5} className="transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-47" data-mp="1em4e1pp3j2wx" />
      </Link>
    </Reveal>;
  return <section aria-label="Who we work with" className="overflow-hidden bg-navy" data-id="element-48" data-mp="1sku9l0w9ouj6">
      <div className="mx-auto grid max-w-7xl lg:grid-cols-12" data-id="element-49" data-mp="3oo8i1emg27mr">
        {renderPath(paths[0], 'order-2 lg:order-1 lg:col-span-4')}

        <div className="relative order-1 h-[280px] sm:h-[340px] lg:order-2 lg:col-span-4 lg:h-auto lg:min-h-[440px]" data-id="element-50" data-mp="3jpx8l5029z52">
          <Suspense fallback={null} data-id="element-51" data-mp="29fq4ttm2drh">
            <NetworkGraphic data-id="element-52" data-mp="2ah1kzejh29q" />
          </Suspense>
          <div className="pointer-events-none absolute inset-x-0 bottom-5 flex justify-center gap-6 text-xs text-white/70" data-id="element-53" data-mp="3tmacevpbltdj">
            <span className="flex items-center gap-2" data-id="element-54" data-mp="b7resqax31ha">
              <span className="h-2 w-2 rounded-full bg-gold" aria-hidden="true" data-id="element-55" data-mp="78a67o071o7w" />
              Professionals
            </span>
            <span className="flex items-center gap-2" data-id="element-56" data-mp="l676auduwcrb">
              <span className="h-2 w-2 rounded-full bg-white/85" aria-hidden="true" data-id="element-57" data-mp="g8otgswpxde1" />
              Organizations
            </span>
          </div>
        </div>

        {renderPath(paths[1], 'order-3 border-t border-gold/30 lg:col-span-4 lg:border-t-0')}
      </div>
    </section>;
}